export function getSubmenuOptions(submenuType, options) {
  const _submenuType = submenuType.toLowerCase().trim()
  if (['quesos franceses', 'french cheeses'].includes(_submenuType)) {
    return options.types_french_cheese
  }
  if (['productos gourmet', 'gourmet products'].includes(_submenuType)) {
    return options.types_gourmet_products
  }
  if (['por región', 'by region'].includes(_submenuType)) {
    return options.french_regions
  }
  if (['viñas', 'vineyards'].includes(_submenuType)) {
    return options.vineyards
  }
  if (['cepas', 'strains'].includes(_submenuType)) {
    return options.strains
  }
  if (['país', 'country'].includes(_submenuType)) {
    return options.countries
  }
  if (['tipos', 'por tipo', 'by type', 'types'].includes(_submenuType)) {
    return options.types
  }
  return [{ text: 'Error', value: 'error' }]
}

export function getSubmenuFilterKey(submenuType) {
  const lang = process.env.VUE_APP_LANG ?? 'es';
  const _submenuType = submenuType.toLowerCase().trim()
  if (['quesos franceses', 'french cheeses'].includes(_submenuType)) {
    return lang === 'es' ? 'tipo_queso' : 'type_cheese';
  }
  if (['productos gourmet', 'gourmet products'].includes(_submenuType)) {
    return lang === 'es' ? 'tipo_gourmet' : 'gourmet_type';
  }
  if (['por región', 'by region'].includes(_submenuType)) {
    return lang === 'es' ? 'region_francia' : 'france_region';
  }
  if (['cepas', 'vineyards'].includes(_submenuType)) {
    return lang === 'es' ? 'variedad' : 'strain';
  }
  if (['viñas', 'strains'].includes(_submenuType)) {
    return lang === 'es' ? 'marca' : 'brand';
  }
  if (['país', 'country'].includes(_submenuType)) {
    return lang === 'es' ? 'pais' : 'country';
  }
  if (['tipos', 'por tipo', 'by type', 'types'].includes(_submenuType)) {
    return lang === 'es' ? 'tipo' : 'type';
  }
  return lang === 'es' ? 'tipo' : 'type';
}

export function getUrlParamsString(valuesPairs) {
  const urlParams = new URLSearchParams()
  Object.keys(valuesPairs).forEach((valuePairKey) => {
    urlParams.set(valuePairKey, valuesPairs[valuePairKey])
  })
  return urlParams.toString()
}

export const showModalDialog = (that, title, description, type) => {
  that.$swal({
    icon: type,
    html:
      '<div class="dialog-container">' +
      '<span class="icon type_icon_' +
      type +
      '"></span>' +
      '<div class="content_dialog_general">' +
      '<span class="titleModal">' +
      title +
      '</span>' +
      '<span class="descriptionModal">' +
      description +
      '</span>' +
      '</div>' +
      '</div>',
    showCloseButton: true,
    showCancelButton: false,
    showConfirmButton: false,
    focusConfirm: false,
  })
}

export function getFormattedPrice(price) {
  const currencyFormatter = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  })

  return currencyFormatter.format(price)
}

export function truncateString(str, num) {
  if (str.length > num) {
    return str.slice(0, num) + '...'
  } else {
    return str
  }
}

export function formatDateDDMMYY(date) {
  const _date = new Date(date)
  return `${_date.getDate()}/${_date.getMonth() + 1}/${_date.getFullYear()}`
}

export const breakpoints = {
  mobile: 480,
  tablet: 780,
}

export function isMobileScreen() {
  return window.matchMedia(`(max-width: ${breakpoints.mobile}px)`).matches
}

export function isTabletScreen() {
  return window.matchMedia(`(max-width: ${breakpoints.tablet}px)`).matches
}

export function separateName(name) {
  const nameArr = name.split(' ')
  if (nameArr.length === 2) {
    return {
      name: nameArr[0],
      lastName: nameArr[1],
    }
  }
  if (nameArr.length === 3) {
    return {
      name: [nameArr[0], nameArr[1]].join(' '),
      lastName: nameArr[2],
    }
  }
  if (nameArr.length === 4) {
    return {
      name: [nameArr[0], nameArr[1]].join(' '),
      lastName: [nameArr[2], nameArr[3]].join(' '),
    }
  }
  return {
    name,
    lastName: name,
  }
}
